import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import type { VehicleBidding } from 'Pages/vehicles/helpers/vehicle.schema';

export const useBiddingSection = (): VehicleBidding => {
	const { bidding } = useVehicleData();

	return bidding;
};
